'user strict'
const ex = require('../lib/error')

const fs = require('fs');
var sharp = require('sharp')
var sizeOf = require('image-size');
require('babel-polyfill')

const MAX_IMAGESIZE = 500

function getHeightAndWidth(dim_width, dim_height){
  var height, width;
  var flag = 0;
  if(dim_width > dim_height){ 
    if(dim_width >= MAX_IMAGESIZE){ 
      width = MAX_IMAGESIZE;
      height = (dim_height * MAX_IMAGESIZE)/dim_width | 0;
      flag = 1;
    }
  }else{
    if(dim_height >= MAX_IMAGESIZE){
      height = MAX_IMAGESIZE
      width = (dim_width * MAX_IMAGESIZE)/dim_height | 0;
      flag = 1;
    }
  }
  if(!flag){
    height = dim_height;
    width = dim_width;
  }
  return [height, width];
}

const imageCompress = async (newpath, h, w, dest, path) => {
  return new Promise((resolve, reject) => {
    return sharp(newpath).resize(w, h).jpeg().toFile(dest, (err) => {
      if (err) {
        resolve(false)
      }
      fs.unlinkSync(path)
      var newSize = sizeOf(dest).height * sizeOf(dest).width;
      console.log(newSize);
      if (newSize >= 10 * 1024 * 1024) {
        fs.unlinkSync(dest);
        resolve(false)
      }
      resolve(true)
    })
  })
}

module.exports = {
  imageCompress,
  getHeightAndWidth,
}